<template>
  <div class="my-5" :class="col ? `col-lg-${col}` : ''">
    <div
      :class="{
        errors: ((showLengthError || validPrefix) && focused) || errors,
      }"
      class="input_wrapper top_label mb-1"
    >
      <label class="form-label">
        {{ placeholder }}
        <span class="text-danger" v-if="required">*</span>
      </label>
      <!-- :key="defaultCountry" -->
      <vue-tel-input
        style="direction: ltr; color: black"
        @input="updateValue"
        :autoFormat="false"
        ref="telInput"
        @country-changed="countryChanged"
        :defaultCountry="defaultCountry"
        :preferredCountries="['SA']"
        @focus="focused = true"
        :disabled="disabled"
        v-model="displayValue"
        :dropdownOptions="{
          showDialCodeInSelection: true,
          showDialCodeInList: true,
          showFlags: true,
          showSearchBox: true,
          // searchBoxPlaceholder: 'Search',
        }"
        :style="
          showLengthError
            ? 'border-color: #dc3546; box-shadow: 0 0 0 1px #dc3546'
            : ''
        "
        :inputOptions="{
          placeholder: null,
          maxlength: maxLength,
          inputmode: 'numeric',
          pattern: '[0-9]*',
        }"
      />
      <!-- :inputOptions="{ placeholder: placeholder }" -->
      <!-- :inputOptions="{ maxlength: maxLength }" -->
      <!-- Error message if phone number too short -->
    </div>
    <span class="text-danger" v-if="errors">
      {{ errors }}
    </span>
    <span class="text-danger" v-if="showLengthError && focused">
      {{
        $t("VALIDATION.PHONE_NUMBER_LENGTH", {
          max: maxLength,
        })
      }}
    </span>
    <span v-if="validPrefix && focused" class="text-danger">
      {{
        $t("VALIDATION.PHONE_NUMBER_PREFIXES", {
          prefixes: validPrefix.join($i18n.locale === "ar" ? " أو " : " or"),
        })
      }}
    </span>
  </div>
</template>

<script>
import CountryCodes from "../../assets/CountryCodes.json";

export default {
  name: "BasePhoneInput",
  props: {
    placeholder: String,
    errors: {
      required: false,
      type: String,
    },
    value: {
      type: String,
      required: true,
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    col: {
      required: false,
      type: String,
    },
    defaultCountry: {
      required: false,
      type: String,
      default: "SA",
    },

    key: {
      required: false,
      type: String,
    },

    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    Country_code: {
      type: String | Number,
      default: null,
    },
  },
  data() {
    return {
      isInitialized: false,
      phonenumber: null,
      touched: false,
      displayValue: this.value,
      currentCountry: null,
      focused: false,
    };
  },

  mounted() {
    this.$nextTick(() => {
      const input = this.$refs.telInput.$el.querySelector("input");
      if (input) {
        input.addEventListener("keypress", this.allowNumbersOnly);
      }
    });
  },
  beforeDestroy() {
    const input = this.$refs.telInput.$el.querySelector("input");
    if (input) {
      input.removeEventListener("keypress", this.allowNumbersOnly);
    }
  },
  computed: {
    resolvedDefaultCountry() {
      const country = CountryCodes?.find(
        (c) => c?.alpha2 === this.Country_code
      );
      return country?.alpha2 || this.defaultCountry;
    },
    maxLength() {
      const isoCode = this.currentCountry ?? this.defaultCountry;
      const country = CountryCodes?.find((c) => c?.alpha2 == isoCode);
      return country ? country?.phone_length : 15;
    },
    validPrefix() {
      const isoCode = this.currentCountry ?? this.defaultCountry;
      const country = CountryCodes?.find((c) => c?.alpha2 == isoCode);

      if (!country || !country.prefixes) return false;

      const phone = this.phonenumber || "";
      const isValid = country.prefixes.some((prefix) =>
        phone.startsWith(prefix)
      );

      return isValid ? false : country.prefixes;
    },

    showLengthError() {
      const length = this.displayValue?.length;
      return this.required && length > 0 && length !== this.maxLength;
    },
  },

  watch: {
    value(newVal) {
      // Update display value when prop changes
      this.displayValue = newVal;
    },
  },

  methods: {
    allowNumbersOnly(event) {
      const char = String.fromCharCode(event.which);
      const isNumber = /[0-9]/.test(char);
      if (!isNumber) {
        event.preventDefault();
      }
    },
    focus() {
      this.$refs.telInput.$el.querySelector("input").focus();
      // ولو vue-tel-input فيه method focus() مباشرة جرب:
      // this.$refs.telInput.focus();
    },
    countryChanged(country) {
      this.currentCountry = country.iso2;
      this.$emit("dialCode", {
        dialCode: country.iso2,
      });
    },

    updateValue(number) {
      let filtered = number.replace(/\D/g, "");
      this.displayValue = filtered;
      this.phonenumber = filtered;
      const length = filtered?.length || 0;
      const hasLengthError = !this.validPrefix || length !== this.maxLength;

      this.$emit("input", filtered);
      this.$emit("hasError", hasLengthError);

      this.touched = true;
      setTimeout(() => {
        this.isInitialized = true;
      }, 5000);
    },
  },
  created() {
    if (this.Country_code) {
      const country = CountryCodes?.find(
        (c) => c?.country_code == this.Country_code
      );
      this.currentCountry = country ? country.alpha2 : this.defaultCountry;
    } else {
      this.currentCountry = this.defaultCountry;
    }
  },
};
</script>

<style lang="scss">
.vue-tel-input {
  width: 100% !important;
}
::v-deep .vti__dropdown-list.below {
  z-index: 99 !important;
  // left: -326px !important;
  min-width: 400px !important;
  margin-top: 13px !important;
}

.input_wrapper.errors {
  border-color: #f44336 !important;
  background-color: transparent !important;
  color: #f44336 !important;
}
.input_wrapper.errors label {
  color: #f44336 !important;
}
.input_wrapper.errors input::placeholder {
  color: #f44336;
}
</style>
